import React from "react";
import { Notabene, IconName, Text } from "@telia/teddy";
import "./NotabeneCard.less";

interface NotabeneCardProps {
    content?: string;
    heading?: string;
    headingTag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
    icon?: IconName;
}

const NotabeneCard: React.FC<NotabeneCardProps> = ({ heading, headingTag = "h2", icon, content }) => {
    return (
        <Notabene className="notabene-card" mt="200">
            <Notabene.Icon name={icon as IconName} />
            <Notabene.Content>
                <Notabene.Heading as={headingTag}>{heading}</Notabene.Heading>
                <Text mb="50" asChild>
                    <div dangerouslySetInnerHTML={{ __html: content ?? "" }} />
                </Text>
            </Notabene.Content>
        </Notabene>
    );
};

export default NotabeneCard;
